import featImg from "@/assets/feat.webp"

import scoreDetails from "@/assets/ScoreDetails.webp"
import assessmentInsights from "@/assets/feat2.webp"
import dashboardImg1 from "@/assets/dashboardImage1.webp"
import dashboardImg2 from "@/assets/dashboardImage2.webp"
export default function Features() {
  return (
    <div className="w-full px-4 lg:px-0">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between items-start md:items-center mb-10 gap-8">
        <div className="w-full lg:w-1/2">
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-800 mb-2 md:leading-relaxed text-left">
            Key Features for <br className="hidden lg:block" />

            Better Hiring
          </h2>
        </div>
        <div className="w-full lg:w-1/2">
          <p className="text-gray-600 text-sm md:text-lg">
            Our features are meticulously crafted to empower you with the tools you
            need to make informed decisions, foster a fair evaluation environment, and
            ultimately build exceptional teams.
          </p>
        </div>
      </div>

      {/* Feature Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-20">
        {/* Left Card: AI Assessments */}
        <div className="relative bg-white rounded-2xl shadow-lg overflow-hidden">
          <img
            src={featImg}
            alt="Assessment Background"
            className="w-full md:h-full h-[100vh] object-cover rounded-2xl"
          />
          <div className="absolute top-0 left-0   md:p-[3.5rem] lg:p-7 text-white">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4 mx-3.5 md:mx-0 mt-5">AI-Driven Assessments</h3>
            <p className="text-sm md:text-lg leading-relaxed mx-3.5 md:mx-0">
              Our AI algorithms evaluate candidates' technical skills, problem-solving abilities,
              and experience, ensuring a comprehensive assessment that goes beyond traditional interviews.
              Create customized online assessment tests specifically curated for each candidate based on the
              role, ensuring relevant and accurate evaluations.
            </p>
          </div>
        </div>

        {/* Right Side Stack */}
        <div className="flex flex-col gap-12">
          {/* Resume Screening Card */}
          <div className="bg-white rounded-2xl shadow-lg px-4 relative pb-24">
            <div className="flex flex-col md:flex-row justify-between gap-4">
              <div className="mt-4 flex-1 pl-2 pr-2">
                <h2 className="text-2xl sm:text-3xl font-bold mb-3 mt-3">AI Resume Screening</h2>
                <p className="text-gray-600 text-[16px] sm:text-[17px]">
                  Utilize AI to match job descriptions with resumes, identifying both matching & missing skills.
                  Evaluate years of experience to generate a comprehensive cumulative score for each candidate.
                </p>
              </div>
              <img src={scoreDetails} alt="Score Details" className="h-72 object-contain mx-auto hidden md:block" />
            </div>
            <div className="md:absolute md:bottom-12 left-12 bg-[#9AB9B1] w-[64px] h-[2px] hidden md:block" />
            <img
              src={assessmentInsights}
              alt="Assessment Insights"
              className="h-48 md:absolute md:bottom-3 md:left-1/2 md:transform md:-translate-x-1/2 hidden md:block"
            />
            <div className="mt-4 sm:mt-3 px-2 block md:hidden">
              <img
                src={assessmentInsights}
                alt="Assessment Pie"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          {/* Dashboard Card */}
          <div className="bg-white rounded-2xl shadow-lg pl-4 sm:pl-6 relative pb-6">
            <div className="grid grid-cols-1 sm:grid-cols-2">
              <div className="mt-6 px-2">
                <h2 className="text-2xl sm:text-3xl font-bold mb-3 mt-3">Dashboard</h2>
                <p className="text-gray-600 text-[16px] sm:text-[17px]">
                  Dashboard that keeps track of hiring trends over months,
                  assessment insights, active jobs and other metrics.
                </p>
              </div>
              <div className="mt-4 sm:mt-3 px-2">
                <img
                  src={dashboardImg2}
                  alt="Assessment Pie"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
            <div className="mt-6 sm:mt-0 px-2">
              <img
                src={dashboardImg1}
                alt="Hiring Trends"
                className="w-full sm:w-[350px] float-none sm:float-right mx-auto sm:mr-10 mt-4 sm:mt-0 mb-3"
              />
            </div>
            <div className="absolute bottom-12 left-12 bg-[#9AB9B1] w-[64px] h-[2px]" />
          </div>
        </div>
      </div>
    </div>

  );
}